// // ReusableButton.js
// import React from 'react';
// import PropTypes from 'prop-types';
// import './tabView.scss'; // Add your custom styles here


// function MakeATabView(properties, tabWidth) {
//     const { selectedTab } = this.state,
//         { tab, label, active, inactive } = properties


//     const setTab = (name, label) => {
//         this.setState({ selectedTab: name, headerValue: '' })
//     }
//     return (
//         <div className={`hunt-planner-map-layer-tab-${selectedTab === tab ? 'active' : 'inactive'}`}
//             style={{ width: tabWidth }}
//             onClick={() => {
//                 if (selectedTab !== tab) {
//                     setTab(tab)
//                 }
//             }}
//             key={`tab-${tab}`}
//         >
//             <div className={`hunt-planner-map-layer-tab-label-${selectedTab === tab ? 'active' : 'inactive'}`}>
//                 {label === 'HuntWind' ? <p>HuntWind&#8482;</p> : label}
//             </div>
//         </div>
//     )
// }


// export default MakeATabView



import React from 'react';
import PropTypes from 'prop-types';
import './tabView.scss'; // Add your custom styles here

const MakeATabView = ({ properties, tabWidth, selectedTab, setTab, tabHeight, tabLabel, tabKey, disable }) => {
    const { tab = false, label = false } = properties;
    const isActive = selectedTab === (tab || tabKey);
    return (
        <div
            className={`hunt-planner-map-layer-tab-${selectedTab === (tab || tabKey) ? 'active' : !disable ? 'inactive' : 'disable-pointer'}`}
            style={{ width: tabWidth, height: tabHeight, borderBottom: isActive ? '3px solid rgb(88, 149, 0)' : 'none', }}
            onClick={() => {
                if (!disable) {
                    if (selectedTab !== (tab || tabKey)) {
                        setTab((tab || tabKey), (label || tabLabel));
                    }
                } else {
                    console.log('wait until data loads')
                }
            }}
        >
            <div className={`hunt-planner-map-layer-tab-label-${selectedTab === (tab || tabKey) ? 'active' : !disable ? 'inactive' : 'disable-pointer'}`}>
                {label}
            </div>
        </div>
    );
};

MakeATabView.propTypes = {
    // properties: PropTypes.shape({
    //     tab: PropTypes.string.isRequired,
    //     label: PropTypes.string.isRequired,
    // }).isRequired,
    tabWidth: PropTypes.string.isRequired,
    tabHeight: PropTypes.string.isRequired,
    selectedTab: PropTypes.string.isRequired,
    setTab: PropTypes.func.isRequired,
};

export default MakeATabView;
